module.exports = __webpack_public_path__ + "img/500.48b225ff.svg";